import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
import { BridgeElement } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  static component = "menu";
  static targets = ["item"];
  static values = { timeout: Boolean };

  connect() {
    if (this.timeoutValue) {
      setTimeout(() => {
        this.#connect();
      }, 1000);
    } else {
      this.#connect();
    }
  }

  #connect() {
    super.connect();

    const items = this.itemTargets.map((item) => {
      const element = new BridgeElement(item);
      return {
        title: element.title,
        iosImage: element.bridgeAttribute("ios-image"),
        androidImage: element.bridgeAttribute("android-image"),
      };
    });

    this.send("connect", { items }, (message) => {
      const item = this.itemTargets[message.data.index];
      new BridgeElement(item).click();
    });
  }

  disconnect() {
    super.disconnect();
    this.send("disconnect");
  }
}
